<template>
  <div class="donation-box">
    <div v-if="landingPage.chatUrl">
      <div class="chat-wrap">
        <iframe class="chat-donation" :src="landingPage.chatUrl" />
      </div>

      <iframe class="ttp-donation" :src="landingPage.donationURL" />
    </div>
    <iframe
      class="iframe-donation"
      v-else-if="landingPage.donationURL"
      width="100%"
      height="100%"
      frameborder="none"
      background="white"
      :src="landingPage.donationURL"
    ></iframe>
    <div v-else>
      <div class="don-wrap">
        <div class="donation w-form" :class="{ open: openDonation }">
          <form
            @submit.prevent="creditCardDonation()"
            name="email-form"
            data-name="Email Form"
            class="form"
            style="width: 100%"
          >
            <a
              id="closeDonation"
              @click="closeDonation()"
              class="close w-button"
              >X</a
            >
            <p>Donation Details</p>
            <input
              type="text"
              class="text-field w-input"
              maxlength="256"
              name="name"
              v-model="donation.name"
              placeholder="Full Name"
              id="name"
            />
            <input
              type="email"
              class="text-field w-input"
              maxlength="256"
              name="email"
              v-model="donation.email"
              placeholder="Email"
              id="email"
            />
            <textarea
              placeholder="Message"
              maxlength="144"
              id="message"
              name="message"
              v-model="donation.message"
              class="text-field big w-input"
            ></textarea>
            <label class="field-label">Donation Amount</label>
            <input
              pattern="[0-9]*"
              type="number"
              inputmode="numeric"
              class="text-field w-input"
              maxlength="256"
              name="amount"
              v-model="donation.amount"
              @input="validateAmount()"
              placeholder
            />
            <div class="div-block"></div>
            <stripe-vue
              v-if="env.VUE_APP_STRIPE_TOKEN"
              :donation="donation"
              @approve="sendDonation($event)"
            />
          </form>
          <div class="w-form-fail">
            <div>Oops! Something went wrong while submitting the form.</div>
          </div>
        </div>
        <div class="thank-you" :class="{ visible: thankyou }">
          <div>{{ thankyou }}</div>
        </div>
      </div>
      <div
        style="
          overflow: scroll;
          position: absolute;
          top: 0;
          bottom: 0;
          right: 0;
          width: 100%;
          padding-bottom: 65px;"
        ref="donationChat"
      >
        <div
          v-for="(donation, i) in donations"
          :key="donation._id"
          class="msg"
          :ref="'msg' + i"
        >
          <div class="paragraph" v-html="donation.message"></div>
          <p class="amount">${{ donation.amount }}</p>
          <p class="msg-name">{{ donation.name }}</p>
        </div>
      </div>
      <a
        id="donate"
        @click="openDonationButton()"
        class="button w-button donate-button"
        :style="
          'background:' +
          landingPage.themeColor +
          ';color:' +
          landingPage.negativeColor
        "
        >Donate</a
      >
    </div>
  </div>
</template>
<style scoped>
.thank-you {
  opacity: 0;
  transition: all 0.2s ease;
  background: black;
  position: absolute;
  z-index: -1;
  color: white;
  padding: 20px 30px;
  border-radius: 10px;
  left: 10%;
  right: 10%;
  top: 20%;
}
.thank-you.visible {
  opacity: 0.7;
  z-index: 10;
}
</style>

<script>
import paypalButton from "./paypal-button";
import stripeVue from "./stripe";
export default {
  name: "donation-box",
  props: { landingPage: Object },
  // eslint-disable-next-line
  components: { paypalButton, stripeVue },
  data() {
    return {
      thankyou: false,
      timeout: "",
      resetPaypal: false,
      openDonation: false,
      donations: [],
      donation: {
        name: "",
        email: "",
        message: "",
        amount: "",
      },
    };
  },
  async mounted() {
    console.log(this.env.VUE_APP_STRIPE_TOKEN);
    let msg = this.$parent.db.collection("donations").sort("_lastUpdatedDate","asc").perPage(200);
    if (!this.landingPage.doNotModerate) msg.query("approved", "=", true);

    let res = await msg.get();
    this.donations = res.data;
    var element = this.$refs.donationChat;
    setTimeout(
      () =>
        element.scrollTo({
          top: element.scrollHeight + element.clientHeight,
          behavior: "smooth",
        }),
      200
    );
    this.listen();
  },
  computed: {
    env() {
      return process.env;
    },
  },
  methods: {
    validateAmount() {
      if (this.donation.amount < 0) this.donation.amount = 0;
    },
    closeDonation() {
      this.openDonation = !this.openDonation;
      this.resetPaypal = true;
    },
    openDonationButton() {
      this.openDonation = !this.openDonation;
    },
    async sendDonation(order) {
      await this.$parent.db.collection("donations").post(this.donation);
      this.openDonation = false;
      this.thankyou = order;
      setTimeout(() => (this.thankyou = ""), 3000);
    },
    listen() {
      this.$parent.db.collection("donations").listen( async ()=>{
        let res = await this.$parent.db
          .collection("donations")
          .query("approved", "=", true)
          .sort("_lastUpdatedDate","asc")
          .perPage(200)
          .get();
        this.donations = res.data;
        var element = this.$refs.donationChat;
        setTimeout(
          () =>
            element.scrollTo({
              top: element.scrollHeight + element.clientHeight,
              behavior: "smooth",
            }),
          200
        );
      });
    },
  },
};
</script>